import { Box, VStack } from "@chakra-ui/react";
import { WidgetTitle } from "@components/Texts/WidgetTitle/WidgetTitle";
import { Tile, TILE_MODES } from "@components/Tiles/Tile";
import React from "react";
import "./scss/index.scss";
import { IProps } from "./types";

export const CategoryArticleList: React.FC<IProps> = ({ posts }: IProps) => {
  return (
    <Box order={{base: 2, md: 0}}>
      <WidgetTitle mb="20px">Znalezione wpisy: {posts.length}</WidgetTitle>
      <VStack spacing="30px" alignItems="flex-start">
        {posts.map((post, i) => (
          <Tile key={post.id} mode={TILE_MODES.SHORT_MOBILE_THUMBNAIL_RIGHT} article={post} />
        ))}
      </VStack>
    </Box>
  );
};
